/* 静态资源加载时间上报 */
const jsReady = (option = {}) => {
    try {
        return window.PerfTrack.jsReady(option);
        // eslint-disable-next-line no-empty
    }
    catch (_) { }
};
/* 请求开始 */
const requestBegin = (option = {}) => {
    try {
        return window.PerfTrack.requestBegin(option);
        // eslint-disable-next-line no-empty
    }
    catch (_) { }
};
/* 接口返回 */
const responseReady = (option = {}) => {
    try {
        return window.PerfTrack.responseReady(option);
        // eslint-disable-next-line no-empty
    }
    catch (_) { }
};
/* DOM渲染完成 */
const domReady = (option) => {
    try {
        return window.PerfTrack.domReady(option);
        // eslint-disable-next-line no-empty
    }
    catch (_) { }
};
/* 核心图片渲染完成 */
const coreImageReady = (option) => {
    try {
        return window.PerfTrack.coreImageReady(option);
        // eslint-disable-next-line no-empty
    }
    catch (_) { }
};
/* 页面全部加载完成 */
const customTTI = (option) => {
    try {
        return window.PerfTrack.customTTI(option);
        // eslint-disable-next-line no-empty
    }
    catch (_) { }
};
/* 自定义埋点 */
const customTrack = (name, extra) => {
    try {
        return window.PerfTrack.customTrack(name, extra);
        // eslint-disable-next-line no-empty
    }
    catch (_) { }
};
const getAppBehaviorParams = () => {
    try {
        return window.PerfTrack.getAppBehaviorParams();
        // eslint-disable-next-line no-empty
    }
    catch (_) {
        return {};
    }
};
const webPerfTrackMethods = {
    jsReady,
    requestBegin,
    responseReady,
    domReady,
    coreImageReady,
    customTTI,
    customTrack,
    getAppBehaviorParams
};
const PerfTrack = {
    ...webPerfTrackMethods,
    init(option) {
        try {
            window.PerfTrack?.init?.(option);
            // eslint-disable-next-line no-empty
        }
        catch (_) { }
        return webPerfTrackMethods;
    }
};
export { PerfTrack };
